/*
创建者 李伟(2018.5.31)
商品列表页面
*/
<template>
  <div id="goods-list-page">
    <div class="breadcrumb wrapper" style="line-height:30px;">
      <span>
        <router-link to="/">首页</router-link>
      </span>
      <span class="arrow">&gt;</span>
      <span>搜索结果</span>
      <span class="arrow">&gt;</span>
      <span>{{this.regionName}}</span>
    </div>
    <div class="container wrapper clearfix">
      <!-- 左侧菜单 -->
      <lefe-tree v-if="landmarkTreeData" :data="landmarkTreeData"></lefe-tree>

      <!-- 右侧商品 -->
      <div class="right" id="result">
        <div class="shop_con_list" id="main-nav-holder">
          <nav class="sort-bar" id="main-nav">
            <input type="hidden" value="desc" name="order">
            <div class="sortbar-array"> 排序方式：
              <ul>
                <li :class="{selected:search_type==0}" @click="searchByType(0)">
                  <a href="javascript:void(0)" title="点击按默认从低到高排序" :class="{'desc':order=='order','asc':order=='asc'}">
                    默认<i></i>
                  </a>
                </li>
                <li :class="{selected:search_type==1}" @click="searchByType(1)">
                  <a href="javascript:void(0)" title="点击按销量从高到低排序" :class="{'desc':order=='order','asc':order=='asc'}">
                    销量<i></i>
                  </a>
                </li>
                <li :class="{selected:search_type==2}" @click="searchByType(2)">
                  <a href="javascript:void(0)" title="点击按价格从高到低排序" :class="{'desc':order=='order','asc':order=='asc'}">
                    价格<i></i>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          <p v-if="!this.loading&&this.list.length==0"
            style="color:red;font-size:20px;text-align:center;margin-top:20px;">
            抱歉,暂无此类商品!
          </p>
          <right-goods :data="list"></right-goods>
          <div v-show="total>0" class="page-wrapper">
            <Page :total="total" :current="page" :page-size="pageSize" show-elevator show-total @on-change="changePage">
            </Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lefeTree from './module-left-tree.vue';
import rightGoods from './module-right-goods.vue';
import { getQueryGoodsByProvince, getlandRegions } from 'api/home';
export default {
  components: {
    lefeTree, rightGoods
  },
  data() {
    return {
      landmarkTreeData: '',
      list: [],
      regionId: "",
      regionName: "",
      search_type: 0,
      oldSearch_type: 0,
      order: "desc",
      page: 1,
      pageSize: 12,
      loading: false,
      total: 0
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "中国地标优品列表") {
        this.regionId = this.$route.query.regionId;
        this.page = 1;
        this.list = [];
        this.search_type = 0;
        this.order = "desc";
        this.fetchData();
        if (!this.landmarkTreeData) {
          this.getlandRegions();
        } else {
          for (var i in this.landmarkTreeData) {
            for (var j in this.landmarkTreeData[i].regions) {
              if (this.landmarkTreeData[i].regions[j].regionId == this.regionId) {
                this.regionName = this.landmarkTreeData[i].name;
              }
            }
          }
        }
      }
    }
  },
  created() {
    this.regionId = this.$route.query.regionId;
    this.fetchData();
    this.getlandRegions();
  },
  methods: {
    changePage(index) {
      this.page = index;
      this.fetchData();
    },
    getlandRegions() {
      getlandRegions().then((json) => {
        if (json.resCode == '1') {
          this.landmarkTreeData = json.data;
          this.regionName = '暂无结果'
          if (this.landmarkTreeData) {
            for (var i in this.landmarkTreeData) {
              for (var j in this.landmarkTreeData[i].regions) {
                if (this.landmarkTreeData[i].regions[j].regionId == this.regionId) {
                  this.regionName = this.landmarkTreeData[i].name;
                }
              }
            }
          }
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },
    fetchData() {
      if (!this.loading) {
        this.total = 0;
        this.loading = true;
        let query = this.$route.query;
        let params = {          ...query,
          searchType: this.search_type,
          pageNo: this.page,
          pageSize: this.pageSize,
          regionId: query.regionId,
          order: this.order
        };
        //order:"asc" 排序 asc 升序 desc 降序
        //this.page,this.pageSize,this.search_type,this.regionId,this.order;
        getQueryGoodsByProvince(params).then(json => {
          if (json.resCode == 1) {
            this.loading = false;
            this.list = json.data.list;
            this.total = json.data.total;
          } else {
            console.log("获取商品列表数据错误！")
          }
        });
      };
    },
    searchByType(type) {
      if (!this.loading) {
        this.list = [];
        this.search_type = type;
        if (this.search_type == this.oldSearch_type) {
          if (this.order == "asc") {
            this.order = "desc";
          } else {
            this.order = "asc";
          }
        } else {
          this.order = "desc";
        }
        this.page = 1;
        this.oldSearch_type = type;
        this.fetchData();
      }
    }
  }
}
</script>
<style scoped>
#goods-list-page .wrapper {
  width: 1200px !important;
  margin: 0 auto;
}
.page-wrapper {
  margin: 20px 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// landmark-goods-list.vue?3e9a802a